import { render, staticRenderFns } from "./ReviewsFrame.vue?vue&type=template&id=381d7496&scoped=true&"
import script from "./ReviewsFrame.vue?vue&type=script&lang=js&"
export * from "./ReviewsFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381d7496",
  null
  
)

export default component.exports